import { Spinner } from '@/components/ui'
import { Notification } from '@/schema'

import { NotificationStatus } from '../../types'
import { EmptyNotificationState } from '../EmptyNotificationState'

import { NotificationItem } from './NotificationItem'

interface NotificationListProps {
  notifications: Notification[]
  activeTab: NotificationStatus
  isPinned?: boolean
  onMarkAsRead?: (id: string) => void
  onMarkAsUnread?: (id: string) => void
  isFetchingNextPage?: boolean
}

export const NotificationList = ({
  notifications,
  activeTab,
  isPinned = false,
  onMarkAsRead,
  onMarkAsUnread,
  isFetchingNextPage,
}: NotificationListProps) => {
  // No need for client-side filtering since it's handled at the API level
  if (notifications.length === 0) {
    return <EmptyNotificationState tab={activeTab} />
  }

  return (
    <div className="flex flex-col gap-0.5">
      {notifications.map((notification) => (
        <NotificationItem
          key={notification.id}
          notification={notification}
          isPinned={isPinned}
          onMarkAsRead={onMarkAsRead}
          onMarkAsUnread={onMarkAsUnread}
        />
      ))}

      {/* Loading indicator for fetching next page */}
      {isFetchingNextPage && (
        <div className="flex items-center justify-center p-2 flex-1">
          <Spinner className="size-8 text-quaternary-600" />
        </div>
      )}
    </div>
  )
}
